import React from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import styles from './StopRenewalModal.css';

class StopRenewalModal extends React.Component {
  render() {
    const { show, onCancel, onProceed, slot } = this.props;
    return (
      <Modal
        show={show}
        onHide={() => {}}
        dialogClassName={`modal-dialog ${styles.dialog}`}
      >
        <Modal.Header bsClass={`modal-header ${styles.header}`}>
          <Modal.Title className={styles.title}>Stop Renewal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {`Are you sure you want to stop renewal for this purchased employee slot? You can keep using this employee slot until ${moment(
            slot.expireDate
          ).format('DD MMM YYYY')}`}
        </Modal.Body>
        <Modal.Footer>
          <span className={styles.right}>
            <button onClick={onCancel} className="btn btn-default">
              Cancel
            </button>
            <button onClick={onProceed} className="btn btn-danger">
              Proceed
            </button>
          </span>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default StopRenewalModal;
